export default __webpack_public_path__ + "static/media/OLPL.bd973632.png";